import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { GetTonePriceRequest } from '../api/tune/gettuneprice/gettonepricerequest';
import { GetTonePriceResponse, GetTonePriceResponseDtoImpl } from '../api/tune/gettuneprice/gettonepriceresponse';
import { GetTonePriceBuilder } from '../dto/gettoneprice/gettonepricebuilder';
import { GetTonePriceDtoImpl } from '../dto/gettoneprice/gettonepricedto';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class GetTonePriceAPIProcessorImpl extends SixdeeCRBTAPIProcessor<GetTonePriceRequest, GetTonePriceResponse>
{
    private LOGGER: Logger = LogManager.getLogger(GetTonePriceAPIProcessorImpl.name);
    execute(request: GetTonePriceRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void {
        this.LOGGER.log("onSuccess() invoked");
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new GetTonePriceResponseDtoImpl(APIFeatures.GET_TONE_PRICE, "Get Tone Price Success");

                let getTonePriceDto = new GetTonePriceDtoImpl();
                getTonePriceDto.setToneDetailsList(new GetTonePriceBuilder(responseMapper.getResponseMap()).buildAll());

                response.setTonePriceDto(getTonePriceDto);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new GetTonePriceResponseDtoImpl(APIFeatures.GET_TONE_PRICE, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new GetTonePriceResponseDtoImpl(APIFeatures.GET_TONE_PRICE, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new GetTonePriceResponseDtoImpl(APIFeatures.GET_TONE_PRICE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
      
            this.getAPIFailure(new GetTonePriceResponseDtoImpl(APIFeatures.GET_TONE_PRICE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/gettonepriceapiprocessor.tsx